import { useQuery } from '@tanstack/react-query';

import { MetadataClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const metadataClient = new MetadataClient(apiBaseUrl);

function useGetAdminAuthorizedForms() {
  return useQuery({
    queryKey: [queryKeys.Metadata.GetAdminAuthorizedForms],
    queryFn: () => metadataClient.getAdminAuthorizedForms(),
    staleTime: 5 * 60 * 1000,
  });
}

export default useGetAdminAuthorizedForms;
